export type AuthResponse = {
    token: string;
    user: User;
}

export const USER_ROLE_ROOT_ADMIN = "Root admin";
export const USER_ROLE_ADMINISTRATOR = "Administrator";
export const USER_ROLE_EDITOR = "Editor";
export const USER_ROLE_USER = "User";

export const isRootAdminRole = (role?: string) => role === USER_ROLE_ROOT_ADMIN;
export const isAdministratorRole = (role?: string) => role === USER_ROLE_ADMINISTRATOR;
export const isAdministrativeRole = (role?: string) => isRootAdminRole(role) || isAdministratorRole(role);

export type User = {
    _id: string;
    fullName: string;
    email: string;
    avatar: string;
    organizations: [string];
    authenticated: boolean;
    role?: string;
}
